




































































import { Component, Prop, Mixins } from 'vue-property-decorator'
import StateMixin from '@/mixins/state'
import { FilePreviewState } from '@/store/files/types'

@Component({})
export default class FilePreviewDialog extends Mixins(StateMixin) {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: Object })
  file?: FilePreviewState;

  @Prop({ type: Boolean, default: false })
  downloadable!: boolean;

  @Prop({ type: Boolean, default: false })
  removable!: boolean

  get icon () {
    if (this.isVideo) {
      return 'video'
    } else {
      return 'file'
    }
  }

  get width () {
    return window.innerWidth * (this.$vuetify.breakpoint.mdAndDown ? 1 : 0.5)
  }

  get isVideo () {
    return this.file?.type.startsWith('video/')
  }
}
